import {useEffect} from 'react';

const SidePanelWrapper = props => {
    useEffect(() => {
        app.store.dispatch(app.actions.ui.sidePanel.openView());
        return () => {
            app.store.dispatch(app.actions.ui.sidePanel.closeView());
        };
    }, []);

    return props.children;
};
export default SidePanelWrapper;
